var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPam(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4872",
    "data-name": "Group 4872",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.589,
    height: 31.232,
    viewBox: "0 0 32.589 31.232",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38654",
    "data-name": "Path 38654",
    d: "M112.09,160.612l-.627-.517a44.4,44.4,0,0,1-11.52-14,41.433,41.433,0,0,1-4.028-12.966l-.119-.806.77-.268a47.077,47.077,0,0,1,15.46-2.671,48.254,48.254,0,0,1,15.583,2.667l.776.265-.12.811a41.435,41.435,0,0,1-4.028,12.967,44.406,44.406,0,0,1-11.52,14.005Zm-14.1-26.963c1.049,6.44,3.788,15.623,14.1,24.4,10.311-8.778,13.052-17.958,14.1-24.4a46.043,46.043,0,0,0-14.165-2.3A44.918,44.918,0,0,0,97.989,133.649Z",
    transform: "translate(-95.796 -129.38)",
    fill: "#ec2727"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_38655",
    "data-name": "Path 38655",
    d: "M201.065,188.941h-6.849l.668-8.322a4.214,4.214,0,1,1,5.513,0Zm-4.715-1.969h2.581l-.588-7.327.5-.318a2.245,2.245,0,1,0-2.405,0l.5.319Z",
    transform: "translate(-181.346 -167.794)",
    fill: "#ec2727"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPam);
export default __webpack_public_path__ + "static/media/pam.2e3fe77e9b22ea5d60023905db59e48b.svg";
export { ForwardRef as ReactComponent };